import { assoc, isEmpty, not } from 'ramda';

export const buildFranchiseConfig = (getMiddleBoolean, prefix) => ({
  hasMaladie: getMiddleBoolean(`${prefix}_FRANCHISE_MALADIE_EST_NECESSAIRE`),
  hasAccident: getMiddleBoolean(`${prefix}_FRANCHISE_ACCIDENT_EST_NECESSAIRE`),
  hasHospitalisation: getMiddleBoolean(`${prefix}_FRANCHISE_HOSPITALISATION_EST_NECESSAIRE`),
  hasToutesCauses: getMiddleBoolean(`${prefix}_FRANCHISE_TTES_CAUSES_EST_NECESSAIRE`)
});

export const hasSeparateFranchises = (franchiseConfig) =>
  (franchiseConfig.hasMaladie || franchiseConfig.hasAccident || franchiseConfig.hasHospitalisation) &&
  !franchiseConfig.hasToutesCauses;

export const selectGuaranteesWithNodes = (guarantees, pricesGuarantees) =>
  pricesGuarantees && not(isEmpty(pricesGuarantees)) ? pricesGuarantees : guarantees;

export const buildFranchiseTabs = (franchiseConfig, baseROData) => {
  const tabs = [];

  if (franchiseConfig.hasMaladie) {
    tabs.push(assoc('label', 'Maladie', baseROData));
  }
  if (franchiseConfig.hasAccident) {
    tabs.push(assoc('label', 'Accident', baseROData));
  }
  if (franchiseConfig.hasHospitalisation) {
    tabs.push(assoc('label', 'Hospi', baseROData));
  }

  return tabs;
};
